import React from "react";
import { ReactComponent as YourSvg } from "../../assets/logos/shopfrombrazil.svg";

const ShopFromBrazil = () => {
  return <YourSvg />;
};

export default ShopFromBrazil;
